export const SECURE_BROWSER_ERROR = 'SECURE_BROWSER_ERROR';

export const setSecureBrowserError = error => ({
    type: SECURE_BROWSER_ERROR,
    error,
});

export const clearSecureBrowserError = () => ({
    type: SECURE_BROWSER_ERROR,
    error: null,
});
